import React, { useEffect, useState, useRef, useContext } from 'react';
import { TextField as MuiTextField } from '@material-ui/core';
import { spacing } from '@material-ui/system';
import styled from 'styled-components/macro';
import { FormContext } from '../../../contexts/FormContext';

import { Button, FormLabel, FormGroup } from '@material-ui/core';
import GetUploadUrl from '../../../utils/GetUploadUrl';
import UploadFile from '../../../utils/UploadFile';
import { s3Path } from '../../../config/Config';

const ModifiedFormGroup = styled(FormGroup)(spacing);

const Video = styled.video`
  width: 360px;
  height: 240px;
  display: block;
`;

const Container = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
`;

const VideoUpload = props => {
  const context = useContext(FormContext);
  const [value, setValue] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [completed, setCompleted] = useState(true);
  let [progress, setProgress] = useState(0);

  function parseChange(e) {
    // console.log("parse change ",e.detail.value,value)
    externalValueUpdated(e.detail.field, e.detail.value);
  }

  useEffect(() => {
    context.events.addEventListener('change', parseChange);
    context.events.addEventListener('isVisible', parseVisible);
    let newvalue = context.getValue(props.data.field);
    setValue(newvalue);
    let checked = checkValue(newvalue);
    context.setFieldStatus(props.data.field, checked.result, checked.error);
    setIsVisible(context.checkVisible(props.data.field));
    return () => {
      context.events.removeEventListener('change', parseChange);
      context.events.removeEventListener('isVisible', parseVisible);
    };
  }, [context]);

  async function parseVisible(e) {
    let fieldToUpdate;

    if (props.data.nested) {
      fieldToUpdate = props.data.subField;
    } else {
      fieldToUpdate = props.data.field;
    }

    if (e.detail.field == fieldToUpdate) {
      setIsVisible(e.detail.isVisible);
    }
  }

  useEffect(() => {
    checkAndUpdateValue(value);
    //console.log("useeffect value updated",value)
  }, [value]);

  function externalValueUpdated(field, externalvalue) {
    if (field == props.data.field && value != externalvalue) {
      setValue(externalvalue);
    }
  }

  function checkValue(value) {
    let result = true;
    let error = '';
    if (props.data.required) {
      if (value.length == 0) {
        result = false;
        error = props.data.name + ' is required';
      } else {
        result = true;
      }
    }

    if (!completed) {
      result = false;
      error = 'File is still uploading, please wait';
    }
    return { result: result, error: error };
  }

  function uploadProgress(uploadProgress) {
    console.log('uploading ', uploadProgress);
    setProgress(uploadProgress);
    if (uploadProgress == 100) {
      console.log('SET COMPLETED TRUE');
      setCompleted(true);
      checkAndUpdateValue(value);
    }
  }

  async function uploadChanged(e) {
    var file = e.target.files[0];
    let filename = file.name;
    let url = await GetUploadUrl(context.data, props.data.uploadFolder + '/' + filename, props.data.apiType);
    if (url.url != '') {
      let uploadurl = url.url;
      setCompleted(false);
      await UploadFile(url.url, file, url.mime, uploadProgress);
      updateValue(url.file);
    }
  }

  function checkAndUpdateValue(val) {
    //console.log("Update value ",props.data.field,val);
    let checked = checkValue(val);
    context.setFieldValue(props.data.field, val, checked.result, checked.error, props.data.dataTypes);
  }

  const updateValue = val => {
    setValue(val);
    let checked = checkValue(val);
    context.setFieldValue(props.data.field, val, checked.result, checked.error, props.data.dataTypes);
  };

  function GetPath(val) {
    let url = s3Path;
    if (val.indexOf(url) === -1) {
      if (val.substring(0, 1) != '/') {
        url += '/';
      }
      url += val;
      return url;
    } else {
      return val;
    }
  }

  return (
    <>
      {isVisible && (
        <>
          <Container>
            <ModifiedFormGroup>
              <FormLabel component="legend">{props.data.name}</FormLabel>
              <input
                accept="video/*"
                style={{ display: 'none' }}
                id={'raised-button-file' + props.data.field}
                multiple
                type="file"
                onChange={uploadChanged}
              />
              <label htmlFor={'raised-button-file' + props.data.field}>
                <Button variant="contained" component="span" color="primary">
                  Upload video
                </Button>
              </label>
              <FormLabel component="legend">Let op: zonder audio speelt je video niet goed af</FormLabel>
              Voortgang {progress}
              {completed && value != '' && (
                <Video controls>
                  <source src={GetPath(value)} type="video/mp4"></source>
                </Video>
              )}
            </ModifiedFormGroup>
          </Container>
        </>
      )}
    </>
  );
};

export default VideoUpload;
